import RoutesBlog from "./Routing/RoutesBlog";
import TopBarV2 from "../src/components/navigation-components-blog/TopBarV2";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ShopProvider } from "./context/ShopContext";
import "./App.css";

function App() {
  return (
      <ShopProvider>
        <AuthProvider>
          <TopBarV2 />
          <div className="page-content">
            <RoutesBlog />
          </div>
        </AuthProvider>
      </ShopProvider>
  );
}

export default App;
